
































































































































import { Component, Watch } from 'vue-property-decorator';
import { StatusEnum, OrderDirEnum } from '@/services/models/Enums';
import Api, { CampaignNoteApi } from './api';
import Form, {Send} from '@/components/form-base';
import { mixins } from 'vue-class-component';
import MenuBase from '@/views/layout/navigation/menu-base';
import moment from 'moment';

@Component
export default class Notes extends mixins(Form, MenuBase) {
  api: CampaignNoteApi = Api;
  notes: Bemob.Note[] = [];

  isEdit: boolean = false;
  editedIndex: number = null;
  noteText: string = '';
  format: string = 'DD MMM YY HH:mm';

  get isCampaigns() {
    return this.is('campaigns') || this.reportDrillCampaign;
  }

  @Watch('isCampaigns')
  onIsCampaignsChanged(value: boolean, oldValue: boolean) {
    if(!value) {
      this.visible = false;
    }
  }

  startEdit(index, text) {
    this.resetErrors()
    this.isEdit = false;
    this.editedIndex = index
    this.noteText = text
  }

  getError(input: string):  any[] {
    let errors = this.pGetError(input);

    return errors
    ? errors.map((error: any) => error)
    : [];
  }

  get campaignId() {
    return this.reportDrillCampaign
      ? this.reportDrillCampaign
      : this.$store.getters.selectedItem.id;
  }

  get visible() {
    return this.$store.state.table.notesOpened;
  }

  set visible(value: boolean) {
    this.$store.commit('tableNotesOpened', value);
  }

  get filter(): Bemob.NoteFilter {
    return {
      status: StatusEnum.active,
      order: 'created',
      orderDir: OrderDirEnum.desc
    };
  }

  @Watch('campaignId', {
    immediate: true
  })
  onCampaignIdChanged(value: string, oldValue: string) {
    this.isEdit = false;
    this.loadNotes(value, this.visible);
  }

  @Watch('visible')
  onVisibleChanged(value: boolean, oldValue: boolean) {
    if(value) {
      this.notes = [];
      this.resetState();
    }

    this.loadNotes(this.campaignId, value);
  }

  getLocalDate(date) {
    return moment.utc(date).tz(this.$store.state.user.defaultTimezone).format(this.format);
  }

  loadNotes(campaignId: string, visible: boolean) {
    if(visible && campaignId) {
      this.api.getNotes(campaignId, this.filter).then(notes => this.notes = notes);
    }
  }

  resetState() {
    this.isEdit = false;
    this.noteText = '';
    this.editedIndex = null;
  }

  @Send()
  saveNote(data) {
    let promise
    if (data) {
      const { id, campaignId, status } = data
      promise = this.api.update(campaignId, id, { note: this.noteText, status })
    } else {
      const note: Bemob.Note = {
        note: this.noteText,
        status: StatusEnum.active
      };
      promise = this.api.create(this.campaignId, note)
    }

    return promise.then((note) => {
      //this.notes.push(note);
      this.resetState();
      return this.api.getNotes(this.campaignId, this.filter)
    }).then((notes:any) => this.notes = notes);
  }

  openEditBlock() {
    this.isEdit = true;
    this.editedIndex = null;
    this.noteText = '';
  }

  deleteNote(note: Bemob.Note) {
    this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
      message: this.t('All selected items will be deleted permanently if you press OK.'),
      onConfirm: () => {
        this.api.delete(this.campaignId, note).then((note) => {
          let index = this.notes.findIndex((item) => item.id === note.id);
          if(index !== -1) {
            this.notes.splice(index, 1);
          }
        }).catch(() => this.bus.emit('toast-error', this.t('Error occurred during note deletion')));
      }
    }})
  }
}
